export default __webpack_public_path__ + "static/media/520.1ec6ef58.png";